// Brand top bar. Replaces the device's default nav for our screens.
// Sticky by default with backdrop-blur and a paper-translucent fill so
// content scrolling underneath stays visible but de-emphasized.
//
// Ported from handoff_input/design/screens/shared.jsx :: ICSTopBar.

import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface TopBarProps {
  left: ReactNode;
  right?: ReactNode;
  /** Default true; pass false for screens that need a static header. */
  sticky?: boolean;
  className?: string;
}

export function TopBar({
  left,
  right,
  sticky = true,
  className,
}: TopBarProps) {
  return (
    <div
      className={cn(
        sticky ? "sticky top-0 z-10" : "static",
        "flex items-center justify-between",
        "px-5 pt-14 pb-3",
        // ICS.bg @ 86% via inline so the value matches the prototype exactly
        "backdrop-blur-md",
        "border-b border-[rgba(60,50,40,0.08)]",
        className,
      )}
      style={{ background: "rgba(250,248,244,0.86)" }}
    >
      <div>{left}</div>
      <div>{right}</div>
    </div>
  );
}
